
import { Space, Table, Tag,Button, Modal, Flex, ConfigProvider, Form, Select, Collapse, DatePicker, Input, Col, Row, notification, Card, Radio, message} from 'antd';
import type { FormProps, TableProps } from 'antd';
import { BudgetRequestInterface } from '../models/IBudgetRequest';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Key, useEffect, useRef, useState } from 'react';
import { MdFileOpen } from "react-icons/md";
import { oecdInterface } from '../models/Ioecd';
import React from 'react';
import Title from 'antd/es/skeleton/Title';
import { AboutResearchInterface, ProjectDataStaffReportInterface } from '../models/IAboutResearch';
import { researcherInterface } from '../models/IUserData';
import moment from 'moment';
import { EmployeeInFacInterface, FacilityInterface } from '../models/IShowUser';
import CkEditor from './ckeditor/ckEditor';
import { Editor } from 'ckeditor5/src/core';
import LoadingOverlay from 'react-loading-overlay-ts';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, TooltipProps, BarChart, Bar, Rectangle, PieChart, Pie } from 'recharts';
import { formatNumber } from './functionLater';
import { joinedParticipantInterface } from '../models/IjoinedResearcher';
import { exportHtmlToDocx, exportHtmlToPdf } from "./ckeditor/ExportAsDoc";



  interface SearcInterface{
    values:string,
    selectedFacID:number,
    Fac_ID:number,
    year:number,
    date:[]
  }  
  
  interface Summary {
    name: string;
    จำนวนโครงการที่ยื่นในระบบ: number;
    จำนวนนักวิจัยที่ยื่นโครงการในระบบ: number;
    โครงการที่ถูกอนุมัติ: number;
    โครงการที่ไม่อนุมัติ: number;
    ยอดทุนที่ขอ: number;
    จำนวนทุนยื่นขอแบบไม่เบิกจ่าย : number;
    จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย : number;
    จำนวนทุนยื่นขอแบบงบอ้อม : number;
    ยอดทุนที่ได้รับ: number;
    ยอดทุนที่ได้รับแบบไม่เบิกจ่าย : number;
    ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย : number;
    ยอดทุนที่ได้รับแบบงบอ้อม : number;
    ยอดทุนที่ได้รับจากโครงการนวัตกรรมนักศึกษา: number;
  }
  interface PieData {
    name :string,
    value : number,
    fill: string
  }
  



  export function Home(){
    const [form] = Form.useForm();
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [RequestPreviewShow,setRequestPreviewShow] = useState<BudgetRequestInterface[]>([]);
    const [RequestPreview,setRequestPreview] = useState<BudgetRequestInterface[]>([]);
    const [showAll,setshowAll] = useState<AboutResearchInterface[]>([]);
    const [show,setshow] = useState<AboutResearchInterface[]>([]);
    const [tmpqueryshow,settmpqueryshow] = useState<AboutResearchInterface[]>([]);
    const [TeacherRequestAmount,setTeacherRequestAmount] = useState(0)
    const [StudentRequestAmount,setStudentRequestAmount] = useState(0)
    const [Fac,setFac] = useState<FacilityInterface[]>([]);
    const [selectedFac,setselectedFac] = useState('')
    const [selectHead,setSelectedHead] = useState('')
    const [ResOp,setResOp] = useState<EmployeeInFacInterface[]>([])
    const [User,setUser] = useState<researcherInterface>();
    const [search,setSearch]= useState('main');
    const id = Number(sessionStorage.getItem("user"))
    const { RangePicker } = DatePicker;
    const [isAcaYear,setAcaYear] = useState(false);

    const [showResOp,setShowResOp] = useState(false);
    const [choiceMod,setchoiceMod] = useState(false);
    const [showCategory,setShowCategory] = useState(false);
    const [openMod,setOpenMod] = useState(false);
    const [exportdata,setExportData] = useState('ss');
    const [PreviewLoading,setPreviewLoading] = useState(true);
    const [creatingLoading,setCreatingLoading]= useState(true);
    const [year,setyear] = useState(new Date().getFullYear());
    const [summary_data,setSummarydata]=useState<Summary[]>([]);
    const [fac_summary_data,setFacSummarydata]=useState<Summary[]>([]);

    const [tmpprojectdata,settmpprojectdata] = useState<ProjectDataStaffReportInterface[]>([]);

    const {ROCKEditors,CKEditors,getHTML} = CkEditor();

    const myref = useRef<Editor | null>(null);
    

    const CustomTooltip = ({ active, payload, label }: TooltipProps<number, string>) => {
      if (active && payload && payload.length > 0) {
        return (
          <div
            className="custom-tooltip"
            style={{
              backgroundColor: '#fff',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
            }}
          >
            <p className="label" style={{ fontWeight: 'bold', marginBottom: '5px' }}>{`หมวดหมู่: ${label}`}</p>
            {payload[0] && (
              <p style={{ color: '#8884d8' }}>{`ยอดทุนที่ขอ: ${Number(payload[0].value).toLocaleString()} บาท`}</p>
            )}
            {payload[1] && (
              <p style={{ color: '#82ca9d' }}>{`ยอดทุนที่ได้รับ: ${Number(payload[1].value).toLocaleString()} บาท`}</p>
            )}
          </div>
        );
      }
    
      return null;
    };
    
    const handleClear = () => {
      setShowResOp(false)
      setselectedFac('')
      setResOp([]); 
      setSelectedHead('')
      console.log('Select was cleared');
    };

    function FilterData(querytype:any){
      if(querytype=='รอตรวจสอบ'){
        setshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
              item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
          )
        )
        settmpqueryshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
              item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
          )
        )

        setShowCategory(true);

        setTeacherRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
              item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่')
              &&item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
        ).length)
        setStudentRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
              item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่')&&
             item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
        ).length)
      }else if(querytype=='กำลังแก้ไข'){
        setshow(
          showAll.filter(
            (item) =>
            (item.project_status === 'แก้ไขตามความเห็นของกรรมการ' ||
              item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย')
             
          )
        )

        settmpqueryshow(
          showAll.filter(
            (item) =>
            (item.project_status === 'แก้ไขตามความเห็นของกรรมการ' ||
              item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย')
             
          )
        )

        setTeacherRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'แก้ไขตามความเห็นของกรรมการ' ||
            item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย')
            &&item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
        ).length)

        setStudentRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'แก้ไขตามความเห็นของกรรมการ' ||
              item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย')
              &&item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
        ).length)
        setShowCategory(false)
      }else if(querytype=='อนุมัติ'){
        setshow(
          showAll.filter(
            (item) =>
              item.project_status === 'อนุมัติ' ||
              item.project_status === 'ไม่อนุมัติ'
          )
        )

        settmpqueryshow(showAll.filter(
          (item) =>
            item.project_status === 'อนุมัติ' ||
            item.project_status === 'ไม่อนุมัติ'
        ))

        setTeacherRequestAmount(showAll.filter(
          (item) =>
            item.project_status === 'อนุมัติ' ||
            item.project_status === 'ไม่อนุมัติ'
        ).length)

        setStudentRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'อนุมัติ' ||
            item.project_status === 'ไม่อนุมัติ')
            &&item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
        ).length)
        setShowCategory(false)
      }else if(querytype=='ทั้งหมด'){
        setshow(showAll)
        settmpqueryshow(showAll)

        setTeacherRequestAmount(showAll.filter(
          (item) => item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
        ).length)
        setStudentRequestAmount(showAll.filter(
          (item) =>
            (item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')
        ).length)
        setShowCategory(false);

      }else if(querytype=='รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'){
        setshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' 
          )
        )
        settmpqueryshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'
          )
        )

        setShowCategory(true);

        setTeacherRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย')
              &&item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
        ).length)
        setStudentRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย')&&
             item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
        ).length)
      }else if(querytype=='รอผลอนุมัติจากคณะกรรมการ'){
        setshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'
          )
        )
        settmpqueryshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'
          )
        )

        setShowCategory(true);

        setTeacherRequestAmount(showAll.filter(
          (item) =>
            (              
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'
            )
              &&item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
        ).length)
        setStudentRequestAmount(showAll.filter(
          (item) =>
            (              
              item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'
            )&&
             item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
        ).length)
      }else if(querytype=='รอการตรวจสอบผลอนุมัติจากกรรมการ'){
        setshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'
          )
        )
        settmpqueryshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'
          )
        )

        setShowCategory(true);

        setTeacherRequestAmount(showAll.filter(
          (item) =>
            (item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ')
              &&item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
        ).length)
        setStudentRequestAmount(showAll.filter(
          (item) =>
            (
              item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ')&&
             item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
        ).length)
      }else if(querytype=='รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'){
        setshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
          )
        )
        settmpqueryshow(
          showAll.filter(
            (item) =>
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
          )
        )

        setShowCategory(true);

        setTeacherRequestAmount(showAll.filter(
          (item) =>
            (
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่')
              &&item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
        ).length)
        setStudentRequestAmount(showAll.filter(
          (item) =>
            (
              item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่')&&
             item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
        ).length)
      }
    }
    
    const getProjectPreview = async()=>{
      setSearch('main')
      if(sessionStorage.getItem(`role`)=='examiner'){
        axios.post(`${process.env.REACT_APP_BASE}/getfilter`,{Fac_ID:sessionStorage.getItem("Fac_ID"),role:`head`}).then(response =>{
          console.log(response.data)
          setshow(response.data)
        })
        axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_fac_worker.php?facid=${sessionStorage.getItem("Fac_ID")}`)
      .then(res=>{
        setResOp(res.data)
      })

          axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${sessionStorage.getItem('user')}`).then(response => {
              console.log(response.data)
              setUser(response.data.userResult[0])
          }).catch(error =>{console.log(error)})

      }else if(sessionStorage.getItem(`role`)=='staff'){
          await axios.get(`${process.env.REACT_APP_BASE}/getallreq`).then(async response=>{
          setshow(response.data);
          setshowAll(response.data);
          settmpqueryshow(response.data)
          setTeacherRequestAmount(response.data.filter(
            (item: { budget_type: string; }) => item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
          ).length)
          setStudentRequestAmount(response.data.filter(
            (item: { budget_type: string; }) =>
              (item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')
          ).length)

          settmpprojectdata(response.data);
          console.log(response.data)
          
          //อิงตามเตือน
          const months = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
            'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
          ];
          
          // Get the current month (0 for January, 1 for February, etc.)
          const currentMonth = new Date().getMonth(); // For example, January returns 0
          
          // Reorder the months array to start from the current month
          const reorderedMonths = months
            .slice(currentMonth + 1) // Get the months from the next month onward
            .concat(months.slice(0, currentMonth + 1)); // Add the months from January to before the current month

          // Create the monthly summary
          let monthlySummary = reorderedMonths.map((month, index) => ({
            name: month,
            จำนวนโครงการที่ยื่นในระบบ: 0,
            จำนวนนักวิจัยที่ยื่นโครงการในระบบ: 0,
            โครงการที่ถูกอนุมัติ: 0,
            โครงการที่ไม่อนุมัติ: 0,
            ยอดทุนที่ขอ: 0,
            จำนวนทุนยื่นขอแบบไม่เบิกจ่าย : 0,
            จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย : 0,
            จำนวนทุนยื่นขอแบบงบอ้อม : 0,
            ยอดทุนที่ได้รับ: 0,
            ยอดทุนที่ได้รับแบบไม่เบิกจ่าย : 0,
            ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย : 0,
            ยอดทุนที่ได้รับแบบงบอ้อม : 0, 
            ยอดทุนที่ได้รับจากโครงการนวัตกรรมนักศึกษา: 0,
          }));
          
          // Check the final monthly summary
          console.log('Monthly Summary:', monthlySummary);

          for(let i = 0;i<12;i++){
            
            const index = reorderedMonths.indexOf(months[i])
            const Projects = filterByMonth(response.data, i);
            monthlySummary[index].จำนวนโครงการที่ยื่นในระบบ = Projects.length
            monthlySummary[index].จำนวนนักวิจัยที่ยื่นโครงการในระบบ = Array.from(
              new Set(Projects.map((item) => item.head_researcher 
              ))
            ).filter((headResearcher) => headResearcher).length
            monthlySummary[index].โครงการที่ถูกอนุมัติ = Projects.filter((item)=>item.project_status === 'อนุมัติ').length
            monthlySummary[index].โครงการที่ไม่อนุมัติ = Projects.filter((item)=>item.project_status === 'ไม่อนุมัติ').length
            monthlySummary[index].ยอดทุนที่ได้รับ = Projects.reduce(
              (sum, item) => sum + (item.AllSum || 0), 
              0
            );
          
          }

          setSummarydata(monthlySummary);
          

          await axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then((res) => {

            setFac(res.data.filter((fac: any) => fac.Fac_ID !== "70"));
          
            // Extract unique Fac_IDs from the correct response data
            const uniqueFacIDs = Array.from(new Set(response.data.map((item: { Fac_ID: any }) => item.Fac_ID)));
            // Map uniqueFacIDs to create the summary
            const FacSum = uniqueFacIDs.map((Fac_ID) => {
              const faculty = res.data.filter((item:any) => item.Fac_ID==Fac_ID);
              let x = response.data
              return {
                name: faculty[0]?.Fac_NameTH || Fac_ID, // Access the first element of the array
                จำนวนโครงการที่ยื่นในระบบ: response.data.filter((item: any)=>item.Fac_ID == Fac_ID).length,
                จำนวนนักวิจัยที่ยื่นโครงการในระบบ: Array.from(
                  new Set(
                    response.data
                      .filter((item: any) => item.Fac_ID == Fac_ID)
                      .map((item: any) => item.head_researcher)
                  )
                ).length,
                โครงการที่ถูกอนุมัติ: x.filter((item: {
                  project_status: string; Fac_ID: unknown; 
                  })=>item.Fac_ID == Fac_ID && item.project_status == `อนุมัติ`).length,
                โครงการที่ไม่อนุมัติ: x.filter((item: {
                  project_status: string; Fac_ID: unknown; 
                  })=>item.Fac_ID == Fac_ID && item.project_status == `ไม่อนุมัติ`).length,
                  ยอดทุนที่ได้รับ: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce(
                  (sum: any, item: { AllSum: any; }) => sum + (item.AllSum || 0), 
                  0
                ),
                ยอดทุนที่ขอ: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce(
                  (sum: any, item: { AllSumHis: any; }) => sum + (item.AllSumHis || 0), 
                  0
                ),
                จำนวนทุนยื่นขอแบบไม่เบิกจ่าย : x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce((sum: number, item: any) => sum + (item.MonetarySum || 0), 0),
                จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย : x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce((sum: number, item: any) => sum + (item.NonMonetarySum || 0), 0),
                จำนวนทุนยื่นขอแบบงบอ้อม : x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce((sum: number, item: any) => sum + (item.IndirectSum || 0), 0),
                ยอดทุนที่ได้รับแบบไม่เบิกจ่าย : x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce((sum: number, item: any) => sum + (item.MonetarySumHis || 0), 0),
                ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย : x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce((sum: number, item: any) => sum + (item.NonMonetarySumHis || 0), 0),
                ยอดทุนที่ได้รับแบบงบอ้อม : x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce((sum: number, item: any) => sum + (item.IndirectSumHis || 0), 0),
                ยอดทุนที่ได้รับจากโครงการนวัตกรรมนักศึกษา: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce((sum: number, item: any) => sum + (item.StudentBudgetSumHis || 0), 0),
              };
            });
          
            console.log(FacSum);
            setFacSummarydata(FacSum);
          });
          
          
        })
      }else if(sessionStorage.getItem(`role`)=='commitee'){
        axios.post(`${process.env.REACT_APP_BASE}/getproforcommittee`,{
          Committee_id:sessionStorage.getItem('user')}).then(response=>{
          setshow(response.data)
          settmpqueryshow(response.data)
          setshowAll(response.data)
          setTeacherRequestAmount(response.data.filter(
            (item: { budget_type: string; }) => item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
          ).length)
          setStudentRequestAmount(response.data.filter(
            (item: { budget_type: string; }) =>
              (item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')
          ).length)
        })
        axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then(res=>{
          setFac(res.data.filter((Fac:any) => Fac.Fac_ID !== 70));
          console.log(res.data.filter((Fac:any) => Fac.Fac_ID !== 70))
        })
      }
      else{
        axios.get(`${process.env.REACT_APP_BASE}/BudgetData/${id}/${sessionStorage.getItem('Fac_ID')}`).then(response =>{
          console.log(response.data)

          setRequestPreview(response.data)
        })
      }
      setCreatingLoading(false);
    
    }//ดึงข้อมูลมาโชว์


    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    
  
    
    const showModal = () => {
      setOpen(true);
    };

    const [state, setState] = React.useState({
          
      series: [
        {
          name: "High - 2013",
          data: [28, 29, 33, 36, 32, 32, 33]
        },
        {
          name: "Low - 2013",
          data: [12, 11, 14, 18, 17, 13, 13]
        }
      ],
      options: {
        chart: {
          height: 350,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.5
          },
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#77B6EA', '#545454'],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: 'Average High & Low Temperature',
          align: 'left'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
          title: {
            text: 'Month'
          }
        },
        yaxis: {
          title: {
            text: 'Temperature'
          },
          min: 5,
          max: 40
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      },
    
    
  });
  const filterByMonth = (data: any[], month: number) => {
    return data.filter((item) => {
      const itemMonth = moment(item.date).month() ;
      return itemMonth === month;
    });
  };
  

    const handleChange = (value: string) =>{
      setselectedFac(value)
      setShowResOp(true)
      axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_fac_worker.php?facid=${value}`)
      .then(res=>{
        setResOp(res.data)
      })
    }

    const handleChangeHead = (value: string) =>{
      setSelectedHead(value);
      console.log(value)

    }

    const handleCreateFiles = async() =>{
      setCreatingLoading(true)
      setchoiceMod(false);
      let header;
      if(search=='academicyear'){
        header = `สรุปผลข้อมูลงานวิจัยที่มีการยื่นประจำปีการศึกษา${year+543}`
      }else if(search=='year'){
        header = `สรุปผลข้อมูลงานวิจัยที่มีการยื่นประจำปี${year+543}`
      }
      else if(search=='main'){
        header = `สรุปผลข้อมูลงานวิจัยย้อนหลัง 1 ปี`
      }else{
        header = `สรุปผลข้อมูลงานวิจัย`
      }
      
      let tmpfiledata = `
      <h2 class="document-title">
        <strong>${header}</strong><br>
      </h2>
      <h3 class="document-subtitle">
        <strong><u>สรุปข้อมูลจำนวนโครงการวิจัยที่ถูกยื่นทั้งหมดแยกตามข้อมูลสถานะโครงการวิจัยในระบบ</u></strong></h3><br/>
        <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
            <colgroup>
              <tbody>
                <tr>
                  <td>
                    <p>สถานะของโครงการ</p>
                  </td>
                  <td>
                    <p>จำนวนโครงการที่ถูกยื่น</p>
                  </td>
                  <td>
                    <p>จำนวนผู้ที่ยื่นโครงการ</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>จำนวนโครงการที่กำลังรอให้ตรวจสอบ</p>
                  </td>
                  <td>
                    <p>${showAll.filter(
                      (item) =>
                        item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
                        item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
                        item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
                        item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
                    ).length}</p>
                  </td>
                  <td>
                    <p>${Array.from(
                      new Set(showAll.map((item) => item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
                      item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
                      item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
                        item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
                      ))
                    ).filter((headResearcher) => headResearcher).length}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>จำนวนโครงการที่กำลังถูกสั่งแก้ไข</p>
                  </td>
                  <td>
                    <p>${showAll.filter(
                      (item) =>
                        item.project_status === 'แก้ไขตามความเห็นของกรรมการ' ||
                        item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'
                    ).length}</p>
                  </td>
                  <td>
                    <p>${Array.from(
                      new Set(showAll.map((item) => item.project_status === 'แก้ไขตามความเห็นของกรรมการ' ||
                        item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'
                      ))
                    ).filter((headResearcher) => headResearcher).length}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>จำนวนโครงการที่ถูกอนุมัติไปแล้ว</p>
                  </td>
                  <td>
                    <p>${showAll.filter(
                      (item) =>
                        item.project_status === 'อนุมัติ' ||
                        item.project_status === 'ไม่อนุมัติ'
                    ).length}</p>
                  </td>
                  <td>
                    <p>${Array.from(
                      new Set(showAll.map((item) => item.project_status === 'อนุมัติ' ||
                        item.project_status === 'ไม่อนุมัติ'
                      ))
                    ).filter((headResearcher) => headResearcher).length}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>จำนวนโครงการที่อยู่ในระบบทั้งหมด</p>
                  </td>
                  <td>
                    <p>${showAll.length}</p>
                  </td>
                  <td>
                    <p>${Array.from(
                      new Set(showAll.map((item) => item.head_researcher
                      ))
                    ).filter((headResearcher) => headResearcher).length}</p>
                  </td>
                </tr>
              </tbody>
            </colgroup>
          </table>
        </figure>
        <br/>
        <h3 class="document-subtitle">
        <strong><u>จำนวนโครงการที่ถูกยื่นในแต่ละคณะวิชาและรายชื่อผู้ยื่นขอโครงการวิจัย</u></strong></h3><br/>
        <figure class="table" style="width:79.3%;">
          <table class="ck-table-resized">
          <tbody>
            <colgroup>
              <tbody>
                <tr>
                  <td>
                    <p>รายชื่อคณะ/สาขาที่มีการยื่นขอเงินทุนวิจัย</p>
                  </td>
                  <td>
                    <p>จำนวนโครงการที่อยู่ในระบบทั้งหมด</p>
                  </td>
                  <td>
                    <p>รายชื่อผู้ยื่นขอเงินทุนวิจัย</p>
                  </td>
                  <td>
                    <p>โครงการที่ถูกอนุมัติ</p>
                  </td>
                  <td>
                    <p>โครงการที่ไม่อนุมัติ</p>
                  </td>
                  <td>
                    <p>จำนวนทุนยื่นขอแบบตัวเงิน(เบิกจ่าย)</p>
                  </td>
                  <td>
                    <p>จำนวนทุนยื่นขอแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้</p>
                  </td>
                  <td>
                    <p>จำนวนทุนยื่นขอแบบไม่เป็นตัวเงิน(งบอ้อม)</p>
                  </td>
                  <td>
                    <p>จำนวนทุนยื่นขอของโครงการนวัตกรรมสำหรับนักศึกษา</p>
                  </td>
                  <td>
                    <p>จำนวนทุนที่ยื่นขอ</p>
                  </td>
                  <td>
                    <p>จำนวนทุนแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้ที่ได้รับ</p>
                  </td>
                  <td>
                    <p>จำนวนทุนแบบตัวเงิน(เบิกจ่าย)ที่ได้รับ</p>
                  </td>
                  <td>
                    <p>จำนวนทุนแบบไม่เป็นตัวเงิน(งบอ้อม)ที่ได้รับ</p>
                  </td>
                  <td>
                    <p>จำนวนทุนที่ได้รับของโครงการนวัตกรรมสำหรับนักศึกษา</p>
                  </td>
                  <td>
                    <p>จำนวนทุนที่ได้รับ</p>
                  </td>
                </tr>
                
      `
      console.log(Fac)
      for(let i = 0;i<fac_summary_data.length;i++ ){
        let tmpfac = Fac.filter((item)=>item.Fac_NameTH==fac_summary_data[i].name)
        console.log(showAll.filter(
          (item) =>
            item.Fac_ID == tmpfac[0].Fac_ID
          ).length)
        tmpfiledata+=`
        <tr>
          <td>
            <p>${tmpfac[0].Fac_NameTH}</p>
          </td>
          <td>
            <p>${showAll.filter(
                (item) =>
                  item.Fac_ID == tmpfac[0].Fac_ID
                ).length}</p>
          </td>
          <td>

          `
      let x = showAll.filter((item) => item.Fac_ID == tmpfac[0].Fac_ID);

      let printedResearchers = new Set(); // Use a Set to track printed values
      if(showAll.filter(
        (item) =>
          item.Fac_ID == tmpfac[0].Fac_ID
      ).length>0)
      {for (let j = 0; j < x.length; j++) {
        if (!printedResearchers.has(x[j].head_researcher)) {
          await axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${x[j].head_researcher}`).then(res=>{
            console.log(res.data.userResult[0].Per_PrefixTH)
            tmpfiledata += `
            <p>${res.data.userResult[0].Per_PrefixTH}${res.data.userResult[0].Per_FNameTH} ${res.data.userResult[0].Per_LNameTH}</p>
          `;
          })
          printedResearchers.add(x[j].head_researcher); // Add the value to the Set
        }
      }}
        let tmpsumdata = fac_summary_data.find((item:any)=>item.name == tmpfac[0].Fac_NameTH)
        console.log(tmpsumdata)
        tmpfiledata+=`
          </td>
          <td>
            <p>${(tmpsumdata?.โครงการที่ถูกอนุมัติ || 0)}</p>
          </td>
          <td>
            <p>${(tmpsumdata?.โครงการที่ไม่อนุมัติ || 0)}</p>
          </td>
          <td>
            <p>${formatNumber(tmpsumdata?.จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย || 0)}</p>
          </td>
          <td>
            <p>${formatNumber(tmpsumdata?.จำนวนทุนยื่นขอแบบไม่เบิกจ่าย || 0)}</p>
          </td>
          <td>
            <p>${formatNumber(tmpsumdata?.จำนวนทุนยื่นขอแบบงบอ้อม || 0)}</p>
          </td>
          <td>
            <p>${formatNumber(tmpsumdata?.ยอดทุนที่ขอ || 0)}</p>
          </td>
          
          <td>
            <p>${formatNumber(tmpsumdata?.ยอดทุนที่ได้รับแบบไม่เบิกจ่าย || 0)}</p>
          </td>
          <td>
            <p>${formatNumber(tmpsumdata?.ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย || 0)}</p>
          </td>
          <td>
            <p>${formatNumber(tmpsumdata?.ยอดทุนที่ได้รับแบบงบอ้อม || 0)}</p>
          </td>
          <td>
            <p>${formatNumber(tmpsumdata?.ยอดทุนที่ได้รับ || 0)}</p>
          </td>
        </tr>
        `
      }
      tmpfiledata+=`
        
              </tbody>
            </colgroup>
          </tbody>
          </table>
        </figure>
        <h3 class="document-subtitle">
        <strong><u>สรุปข้อมูลโครงการแบบแยกตามรายเดือน</u></strong></h3><br/>
        <figure class="table" style="width:79.3%;">
        <table class="ck-table-resized">
          <tbody>
            <colgroup>
              <tbody>
                <tr>
                  <td>
                    <p>เดือน</p>
                  </td>
                  <td>
                    <p>จำนวนโครงการที่ยื่นในระบบ</p>
                  </td>
                  <td>
                    <p>จำนวนนักวิจัยที่ยื่นโครงการในระบบ</p>
                  </td>
                  <td>
                    <p>โครงการที่ถูกอนุมัติ</p>
                  </td>
                  <td>
                    <p>โครงการที่ไม่อนุมัติ</p>
                  </td>
                </tr>
      `
      for(let i = 0;i<summary_data.length;i++){
        tmpfiledata+=`
        <tr>
          <td>
             <p>${summary_data[i].name}</p>
          </td>
          <td>
            <p>${summary_data[i].จำนวนโครงการที่ยื่นในระบบ}</p>
          </td>
          <td>
            <p>${summary_data[i].จำนวนนักวิจัยที่ยื่นโครงการในระบบ}</p>
          </td>
          <td>
            <p>${summary_data[i].โครงการที่ถูกอนุมัติ}</p>
          </td>
          <td>
            <p>${summary_data[i].โครงการที่ไม่อนุมัติ}</p>
          </td>
        </tr>`
      }
      tmpfiledata+=`</tbody>
            </colgroup>
          </tbody>
          </table>
        </figure>`

      setExportData(tmpfiledata)
      setPreviewLoading(false)
      setCreatingLoading(false)
      setOpenMod(true)
      
    }

    const handleCreateFilesForStaff = async() =>{
      setchoiceMod(false);
      let header;
      if(search=='academicyear'){
        header = `สรุปผลข้อมูลงานวิจัยที่มีการยื่นประจำปีการศึกษา${year+543}`
      }else if(search=='year'){
        header = `สรุปผลข้อมูลงานวิจัยที่มีการยื่นประจำปี${year+543}`
      }
      else if(search=='main'){
        header = `สรุปผลข้อมูลงานวิจัยย้อนหลัง 1 ปี`
      }
      
      let tmpfiledata=`
      <h2 class="document-title">
        <strong>${header}</strong><br>
      </h2>
      <h3 class="document-subtitle">
        <strong><u>สรุปข้อมูลโครงการวิจัยที่ถูกยื่นในระบบ</u></strong>
      </h3>
      <br/>
      `;
      await axios.post(`${process.env.REACT_APP_BASE}/getfilter`,{role:'staff'}).then(
        response=>{
          console.log(response.data);
        }
      ).then(async ()=>{
        for(let i = 0;i<fac_summary_data.length;i++){
          tmpfiledata+=`
              <p><strong>สรุปผลโครงการจากคณะ${fac_summary_data[i].name}</strong><p>
              <p><u>โครงการที่มีสถานะรอตรวจสอบ</u><p>
            `
            let tmpfac = Fac.filter((item)=>item.Fac_NameTH==fac_summary_data[i].name)
            console.log(tmpfac);
            let tmpdata = tmpprojectdata.filter((item)=>item.Fac_ID==tmpfac[0].Fac_ID);
            //รอตรวจสอบ
            tmpfiledata+=`
            <figure class="table" style="width:79.3%;">
              <table class="ck-table-resized">
                <colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <p>ลำดับ</p>
                      </td>
                      <td>
                        <p>ชื่อโครงงานภาษาไทย</p>
                      </td>
                      <td>
                        <p>ชื่อโครงงานภาษาอังกฤษ</p>
                      </td>
                      <td>
                        <p>หัวหน้าโครงการ</p>
                      </td>
                      <td>
                        <p>ผู้ร่วมวิจัย</p>
                      </td>
                        <td>
                          <p>จำนวนทุนยื่นขอแบบตัวเงิน(เบิกจ่าย)</p>
                        </td>
                        <td>
                          <p>จำนวนทุนยื่นขอแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้</p>
                        </td>
                        <td>
                          <p>จำนวนทุนยื่นขอแบบไม่เป็นตัวเงิน(งบอ้อม)</p>
                        </td>
                        <td>
                          <p>จำนวนทุนยื่นขอของโครงการนวัตกรรมสำหรับนักศึกษา</p>
                        </td>
                        <td>
                          <p>จำนวนทุนที่ยื่นขอ</p>
                        </td>
                        <td>
                          <p>จำนวนทุนแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้ที่ได้รับ</p>
                        </td>
                        <td>
                          <p>จำนวนทุนแบบตัวเงิน(เบิกจ่าย)ที่ได้รับ</p>
                        </td>
                        <td>
                          <p>จำนวนทุนแบบไม่เป็นตัวเงิน(งบอ้อม)ที่ได้รับ</p>
                        </td>
                        <td>
                          <p>จำนวนทุนที่ได้รับของโครงการนวัตกรรมสำหรับนักศึกษา</p>
                        </td>
                        <td>
                          <p>จำนวนทุนที่ได้รับ</p>
                        </td>
                      </tr>
            `
                let WaitTMP = tmpdata.filter((item)=>
                  item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
                  item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
                  item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
                  item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่')
                  console.log(WaitTMP)
                  const projectRows = await Promise.all(
                    WaitTMP.map(async (project, index) => {

                      let collaboratorsHTML = '<p>ไม่มีผู้ร่วมวิจัย</p>';
                      try {
                        const response = await axios.get(
                          `${process.env.REACT_APP_BASE}/BudgetReqInfo/${project.Budget_req_id}/${project.head_researcher}`
                        );
                
                        const subInfo = response.data.subInfo;
                        if (subInfo.length > 0) {
                          collaboratorsHTML = subInfo
                            .map((sub: { head_name_th: any; }) => `<p>${sub.head_name_th}</p>`)
                            .join('');
                        }
                      } catch (error) {
                        console.error('Error fetching budget info:', error);
                      }
                
                      return `
                        <tr>
                          <td><p>${index + 1}</p></td>
                          <td><p>${project.project_name_th}</p></td>
                          <td><p>${project.project_name_en}</p></td>
                          <td><p>${project.head_name_th}</p></td>
                          <td>${collaboratorsHTML}</td>
                          <td><p>${formatNumber(Number(project.MonetarySumHis))}</p></td>
                          <td><p>${formatNumber(Number(project.NonMonetarySumHis))}</p></td>
                          <td><p>${formatNumber(Number(project.IndirectSumHis))}</p></td>
                          <td><p>${formatNumber(Number(project.StudentBudgetSumHis))}</p></td>
                          <td><p>${formatNumber(Number(project.AllSumHis))}</p></td>
                          <td><p>${formatNumber(Number(project.MonetarySum))}</p></td>
                          <td><p>${formatNumber(Number(project.NonMonetarySum))}</p></td>
                          <td><p>${formatNumber(Number(project.IndirectSum))}</p></td>
                          <td><p>${formatNumber(Number(project.StudentBudgetSum))}</p></td>
                          <td><p>${formatNumber(Number(project.AllSum))}</p></td>
                        </tr>
                      `;
                    })
                  );
                  
              tmpfiledata += projectRows.join('');
            

            
            tmpfiledata+=`
                  </tbody>
                </colgroup>
              </table>
            </figure>
    
            <p><u>โครงการที่มีสถานะกำลังแก้ไข</u><p>
            <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
              <colgroup>
                <tbody>
                  <tr>
                    <td>
                      <p>ลำดับ</p>
                    </td>
                    <td>
                      <p>ชื่อโครงงานภาษาไทย</p>
                    </td>
                    <td>
                      <p>ชื่อโครงงานภาษาอังกฤษ</p>
                    </td>
                    <td>
                      <p>หัวหน้าโครงการ</p>
                    </td>
                    <td>
                      <p>ผู้ร่วมวิจัย</p>
                    </td>
                    <td>
                        <p>จำนวนทุนยื่นขอแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้</p>
                      </td>
                      <td>
                        <p>จำนวนทุนยื่นขอแบบตัวเงิน(เบิกจ่าย)</p>
                      </td>
                      <td>
                        <p>จำนวนทุนยื่นขอแบบไม่เป็นตัวเงิน(งบอ้อม)</p>
                      </td>
                       <td>
                          <p>จำนวนทุนยื่นขอแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้</p>
                        </td>
                      <td>
                        <p>จำนวนทุนที่ยื่นขอ</p>
                      </td>
                      <td>
                        <p>จำนวนทุนแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้ที่ได้รับ</p>
                      </td>
                      <td>
                        <p>จำนวนทุนแบบตัวเงิน(เบิกจ่าย)ที่ได้รับ</p>
                      </td>
                      <td>
                        <p>จำนวนทุนแบบไม่เป็นตัวเงิน(งบอ้อม)ที่ได้รับ</p>
                      </td>
                      <td>
                          <p>จำนวนทุนที่ได้รับของโครงการนวัตกรรมสำหรับนักศึกษา</p>
                      </td>
                      <td>
                        <p>จำนวนทุนที่ได้รับ</p>
                      </td>
                    </tr>`

            let EditTMP = tmpdata.filter((item)=>
              item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย' ||
              item.project_status === 'แก้ไขตามความเห็นของกรรมการ')
            const editingProjectRow = await Promise.all(
              EditTMP.map(async (project, index) => {
                let collaboratorsHTML = '<p>ไม่มีผู้ร่วมวิจัย</p>';
                try {
                  const response = await axios.get(
                    `${process.env.REACT_APP_BASE}/BudgetReqInfo/${project.Budget_req_id}/${project.head_researcher}`
                  );
          
                  const subInfo = response.data.subInfo;
                  if (subInfo.length > 0) {
                    collaboratorsHTML = subInfo
                      .map((sub: { head_name_th: any; }) => `<p>${sub.head_name_th}</p>`)
                      .join('');
                  }
                } catch (error) {
                  console.error('Error fetching budget info:', error);
                }
          
                return `
                  <tr>
                    <td><p>${index + 1}</p></td>
                    <td><p>${project.project_name_th}</p></td>
                    <td><p>${project.project_name_en}</p></td>
                    <td><p>${project.head_name_th}</p></td>
                    <td>${collaboratorsHTML}</td>
                    <td><p>${formatNumber(Number(project.MonetarySumHis))}</p></td>
                    <td><p>${formatNumber(Number(project.NonMonetarySumHis))}</p></td>
                    <td><p>${formatNumber(Number(project.IndirectSumHis))}</p></td>
                    <td><p>${formatNumber(Number(project.StudentBudgetSumHis))}</p></td>
                    <td><p>${formatNumber(Number(project.AllSumHis))}</p></td>
                    <td><p>${formatNumber(Number(project.MonetarySum))}</p></td>
                    <td><p>${formatNumber(Number(project.NonMonetarySum))}</p></td>
                    <td><p>${formatNumber(Number(project.IndirectSum))}</p></td>
                    <td><p>${formatNumber(Number(project.StudentBudgetSum))}</p></td>
                    <td><p>${formatNumber(Number(project.AllSum))}</p></td>
                  </tr>
                `;
              })
            );

            tmpfiledata += editingProjectRow.join('');
    
                    tmpfiledata+=`
                          </tbody>
                        </colgroup>
                      </table>
                    </figure>
                    <p><u>โครงการที่มีสถานะอนุมัติ/ไม่อนุมัติ</u><p>
                    <figure class="table" style="width:79.3%;">
            <table class="ck-table-resized">
              <colgroup>
                <tbody>
                  <tr>
                    <td>
                      <p>ลำดับ</p>
                    </td>
                    <td>
                      <p>ชื่อโครงงานภาษาไทย</p>
                    </td>
                    <td>
                      <p>ชื่อโครงงานภาษาอังกฤษ</p>
                    </td>
                    <td>
                      <p>หัวหน้าโครงการ</p>
                    </td>
                    <td>
                      <p>ผู้ร่วมวิจัย</p>
                    </td>
                    <td>
                        <p>จำนวนทุนยื่นขอแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้</p>
                      </td>
                      <td>
                        <p>จำนวนทุนยื่นขอแบบตัวเงิน(เบิกจ่าย)</p>
                      </td>
                      <td>
                        <p>จำนวนทุนยื่นขอแบบไม่เป็นตัวเงิน(งบอ้อม)</p>
                      </td>
                      <td>
                          <p>จำนวนทุนยื่นขอของโครงการนวัตกรรมสำหรับนักศึกษา</p>
                      </td>
                      <td>
                        <p>จำนวนทุนที่ยื่นขอ</p>
                      </td>
                      <td>
                        <p>จำนวนทุนแบบไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้ที่ได้รับ</p>
                      </td>
                      <td>
                        <p>จำนวนทุนแบบตัวเงิน(เบิกจ่าย)ที่ได้รับ</p>
                      </td>
                      <td>
                        <p>จำนวนทุนแบบไม่เป็นตัวเงิน(งบอ้อม)ที่ได้รับ</p>
                      </td>
                      <td>
                          <p>จำนวนทุนที่ได้รับของโครงการนวัตกรรมสำหรับนักศึกษา</p>
                      </td>
                      <td>
                        <p>จำนวนทุนที่ได้รับ</p>
                      </td>
                    </tr>
                    `

                    let ApprovedTMP = tmpdata.filter((item)=>
                      item.project_status === 'อนุมัติ' ||
                      item.project_status === 'ไม่อนุมัติ')
                      const ApprovedProjectRow = await Promise.all(
                        ApprovedTMP.map(async (project, index) => {
                          let collaboratorsHTML = '<p>ไม่มีผู้ร่วมวิจัย</p>';
                          try {
                            const response = await axios.get(
                              `${process.env.REACT_APP_BASE}/BudgetReqInfo/${project.Budget_req_id}/${project.head_researcher}`
                            );
                    
                            const subInfo = response.data.subInfo;
                            if (subInfo.length > 0) {
                              collaboratorsHTML = subInfo
                                .map((sub: { head_name_th: any; }) => `<p>${sub.head_name_th}</p>`)
                                .join('');
                            }
                          } catch (error) {
                            console.error('Error fetching budget info:', error);
                          }
                    
                          return `
                            <tr>
                              <td><p>${index + 1}</p></td>
                              <td><p>${project.project_name_th}</p></td>
                              <td><p>${project.project_name_en}</p></td>
                              <td><p>${project.head_name_th}</p></td>
                              <td>${collaboratorsHTML}</td>
                              <td><p>${formatNumber(Number(project.MonetarySumHis))}</p></td>
                              <td><p>${formatNumber(Number(project.NonMonetarySumHis))}</p></td>
                              <td><p>${formatNumber(Number(project.IndirectSumHis))}</p></td>
                              <td><p>${formatNumber(Number(project.StudentBudgetSumHis))}</p></td>
                              <td><p>${formatNumber(Number(project.AllSumHis))}</p></td>
                              <td><p>${formatNumber(Number(project.MonetarySum))}</p></td>
                              <td><p>${formatNumber(Number(project.NonMonetarySum))}</p></td>
                              <td><p>${formatNumber(Number(project.IndirectSum))}</p></td>
                              <td><p>${formatNumber(Number(project.StudentBudgetSum))}</p></td>
                              <td><p>${formatNumber(Number(project.AllSum))}</p></td>
                            </tr>
                          `;
                        })
                      );

                      tmpfiledata += ApprovedProjectRow.join('');
    
                    tmpfiledata+=`
                          </tbody>
                        </colgroup>
                      </table>
                    </figure>
                    `
          
          }
      })
      
      
      setExportData(tmpfiledata)
      setPreviewLoading(false)
      setCreatingLoading(false)
      setOpenMod(true)
      
    }

    useEffect(()=>{
      getProjectPreview();
      sessionStorage.setItem("project_id",``)
  },[]);
    
      

    const columns : TableProps<BudgetRequestInterface>['columns']=[
      {
          title:'ชื่อโครงการ',
          dataIndex:'project_name_th',
          key:'project_name_th',
      },
      {
          title:'ประเภทของโครงการวิจัย',
          dataIndex:'project_type',
          key:'project_type',
          responsive:['xl'],
          render:(_,record)=>{
            let project_type_ = ""
            switch(record.project_type){
              case 1:
                project_type_ = "งานวิจัยเชิงวัฒนธรรม";
                break;
              case 2:
                project_type_ = "งานนวัตกรรม";
                break;
              case 3:
                project_type_ = "งานวิจัยเพื่อสร้างองค์ประกอบความรู้พื้นฐาน";
                break;
              case 4:
                project_type_ = "งานวิจัยเชิงประยุกต์";
                break;
              case 5:
                project_type_ = "งานสร้างสรรค์(หนังสั้น สารคดี โฆษณา)";
                break;
              case 6:
                project_type_ = "งานวิจัยประเมินหลักสูตร";
                break;
              case 7:
                project_type_ = record.other_project_type;
                break;
            }
            return project_type_
          }
      },
      {
          title:'สาขาวิชาที่ทำการวิจัย',
          dataIndex:'oecd_type',
          key:'oecd_type',
          
      },
      {
          title: 'สถานะโครงการ',
          key: 'project_status',
          dataIndex: 'project_status',
          responsive:['lg'],
          render: (project_status: string) => {
            let color = 'white';
            if (project_status === 'กำลังตรวจสอบ') {
              color = 'geekblue';
            } else if (project_status === 'แก้ไข'
              || project_status ==='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น'
              || project_status ==='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'
              || project_status ==='แก้ไขตามความเห็นของกรรมการ'
            ) {
              color = 'yellow';
            } else if (project_status === 'รออนุมัติ') {
              color = 'geekblue';
            } else if (project_status === 'รอตรวจสอบจากผู้บังคับบัญชาเบื้องต้น' 
              || project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'
              || project_status === 'รอผลอนุมัติจากคณะกรรมการ'
            ) {
              color = 'geekblue';
            }else if(project_status == 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
              project_status == 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
            ){
              color = 'geekblue';
            }
            else if (project_status === 'ไม่อนุมัติ') {
              color = 'volcano';
            } else if (project_status === 'อนุมัติ') {
              color = 'green';
            } else  {
              color = 'yellow';
            } 
            return <Tag color={color}>{project_status}</Tag>;
          },
        },
        {
          title: '',
          key: 'action',
          render: (_, record) => (
            <Space size="middle">
                <Button type="primary" onClick={()=>sessionStorage.setItem("project_id",`${record.Budget_req_id}`)}><a href={`/VRIIS/BudgetReqInfo/${record.Budget_req_id}`}>ดูข้อมูล</a></Button>
                {checkstatus(record.project_status,record.Budget_req_id)}
            </Space>
          ),
        },
    ];
    function refreshPage(){ 
      window.location.reload(); 
  }
    const handleOk = () => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setOpen(false);
        axios.delete(`${process.env.REACT_APP_BASE}/DeleteBudget/${selectedId}`).then(
          res=>{
            console.log('deleted',res)
          }
          
        ).catch(error=>{
          console.log(error)
        })
        refreshPage();
      }, 3000);
    };
  
    const handleCancel = () => {
      console.log('Clicked cancel button');
      setOpen(false);
    };

    const searchdata : FormProps<SearcInterface>['onFinish'] = async (values:any)=>{
      console.log(values)
      let data,query;
      
      if(sessionStorage.getItem(`role`)=='commitee'){
        data = {
          year: isAcaYear ? values.academicyear : values.year,
          isAca : isAcaYear,
          head_name_th : selectHead,
          date : values.date,
          selectedFacID : selectedFac,
          Committee_id : sessionStorage.getItem("user")
        } 
        query = `${process.env.REACT_APP_BASE}/getproforcommittee`
      }else if(sessionStorage.getItem(`role`)=='staff'){
        data = {
          role : 'staff',
          isAca : isAcaYear,
          year: isAcaYear ? values.academicyear : values.year,
          head_name_th : selectHead,
          date: values.date?.length
          ? [values.date[0]?.format('YYYY-MM-DD'), values.date[1]?.format('YYYY-MM-DD')]
          : [],
          selectedFacID : selectedFac,
        }
        
        query=`${process.env.REACT_APP_BASE}/getfilter`
      }
      else{
        data = {
          role : 'head',
          isAca : isAcaYear,
          year: isAcaYear ? values.academicyear : values.year,
          head_name_th : values.head_name_th,
          date : values.date?.length
          ? [values.date[0]?.format('YYYY-MM-DD'), values.date[1]?.format('YYYY-MM-DD')]
          : [],
          selectedFacID : selectedFac,
          Fac_ID : sessionStorage.getItem('Fac_ID'),
        }
        query=`${process.env.REACT_APP_BASE}/getfilter`
      }
      if(values.academicyear){
        setSearch('academicyear')
      }else if(values.year)
      {setSearch('year')}
      else
      {setSearch('search')}
      console.log(values)
      console.log(data)
      try{
        await axios.post(query,data)
        .then(response=>{
          console.log(response)
          setshow(response.data);
          setshowAll(response.data);
          settmpqueryshow(response.data)
          setTeacherRequestAmount(response.data.filter(
            (item: { budget_type: string; }) => item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
          ).length)
          setStudentRequestAmount(response.data.filter(
            (item: { budget_type: string; }) =>
              (item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')
          ).length)
          if(values.academicyear||(selectedFac!=''&&selectHead=='')){
            settmpprojectdata(response.data);
          let tmpyear = new Date(values.academicyear);
          setyear(tmpyear.getFullYear());
          const months = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
            'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
          ];
          const reorderedMonths = [
            'มิถุนายน','กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 
            'ธันวาคม','มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม',
          ];
        
          // Create an empty summary structure
          let monthlySummary = reorderedMonths.map((month, index) => ({
            name: month,
            จำนวนโครงการที่ยื่นในระบบ: 0,
            จำนวนนักวิจัยที่ยื่นโครงการในระบบ: 0,
            โครงการที่ถูกอนุมัติ: 0,
            โครงการที่ไม่อนุมัติ: 0,
            ยอดทุนที่ขอ: 0,
            จำนวนทุนยื่นขอแบบไม่เบิกจ่าย : 0,
            จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย : 0,
            จำนวนทุนยื่นขอแบบงบอ้อม : 0,
            ยอดทุนที่ได้รับ: 0,
            ยอดทุนที่ได้รับแบบไม่เบิกจ่าย : 0,
            ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย : 0,
            ยอดทุนที่ได้รับแบบงบอ้อม : 0,
            ยอดทุนที่ได้รับจากโครงการนวัตกรรมนักศึกษา: 0,
          }));

          for(let i = 0;i<12;i++){
            
            const index = reorderedMonths.indexOf(months[i])
            console.log(index)
            const Projects = filterByMonth(response.data, i);
            console.log(Projects);
            console.log(monthlySummary[index])
            monthlySummary[index].จำนวนโครงการที่ยื่นในระบบ = Projects.length
            monthlySummary[index].จำนวนนักวิจัยที่ยื่นโครงการในระบบ = Array.from(
              new Set(Projects.map((item) => item.head_researcher 
              ))
            ).filter((headResearcher) => headResearcher).length
            monthlySummary[index].โครงการที่ถูกอนุมัติ = Projects.filter((item)=>item.project_status === 'อนุมัติ').length
            monthlySummary[index].โครงการที่ไม่อนุมัติ = Projects.filter((item)=>item.project_status === 'ไม่อนุมัติ').length
            monthlySummary[index].ยอดทุนที่ได้รับ = Projects.reduce(
              (sum, item) => sum + (item.AllSum || 0), 
              0
            );
          
            console.log(Projects)
          console.log(Array.from(
            new Set(Projects.map((item) => item.head_researcher 
            ))
          ))}
          


          setSummarydata(monthlySummary)

          const uniqueFacIDs = Array.from(new Set(response.data.map((item: { Fac_ID: any }) => item.Fac_ID)));

          const FacSum = uniqueFacIDs.map((Fac_ID) => {
            const facultyProjects = response.data.filter((item: any) => item.Fac_ID == Fac_ID);
            const faculty = Fac.find((item: any) => item.Fac_ID == Fac_ID);
            const uniqueResearchers = Array.from(new Set(facultyProjects.map((item: any) => item.head_researcher)));
          
            return {
              name: String(faculty?.Fac_NameTH || Fac_ID),
              จำนวนโครงการที่ยื่นในระบบ: facultyProjects.length,
              จำนวนนักวิจัยที่ยื่นโครงการในระบบ: uniqueResearchers.filter(Boolean).length,
              โครงการที่ถูกอนุมัติ: facultyProjects.filter((item: any) => item.project_status === 'อนุมัติ').length,
              โครงการที่ไม่อนุมัติ: facultyProjects.filter((item: any) => item.project_status === 'ไม่อนุมัติ').length,
              ยอดทุนที่ได้รับ: facultyProjects.reduce((sum: number, item: any) => sum + (item.AllSum || 0), 0),
              ยอดทุนที่ขอ: facultyProjects.reduce((sum: number, item: any) => sum + (item.AllSumHis || 0), 0),
              จำนวนทุนยื่นขอแบบไม่เบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.MonetarySum || 0), 0),
              จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.NonMonetarySum || 0), 0),
              จำนวนทุนยื่นขอแบบงบอ้อม : facultyProjects.reduce((sum: number, item: any) => sum + (item.IndirectSum || 0), 0),
              ยอดทุนที่ได้รับแบบไม่เบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.MonetarySumHis || 0), 0),
              ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.NonMonetarySumHis || 0), 0),
              ยอดทุนที่ได้รับแบบงบอ้อม : facultyProjects.reduce((sum: number, item: any) => sum + (item.IndirectSumHis || 0), 0),
              ยอดทุนที่ได้รับจากโครงการนวัตกรรมนักศึกษา : facultyProjects.reduce((sum: number, item: any) => sum + (item.StudentBudgetSumHis || 0), 0),
            };
          });
          
          console.log(FacSum);
          setFacSummarydata(FacSum);
        }else if(values.year){
          let tmpyear = new Date(values.year);
          setyear(tmpyear.getFullYear());

          const months = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
            'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
          ];
          let monthlySummary = months.map((month, index) => ({
            name: month,
            จำนวนโครงการที่ยื่นในระบบ: 0,
            จำนวนนักวิจัยที่ยื่นโครงการในระบบ: 0,
            โครงการที่ถูกอนุมัติ: 0,
            โครงการที่ไม่อนุมัติ: 0,
            ยอดทุนที่ขอ: 0,
            จำนวนทุนยื่นขอแบบไม่เบิกจ่าย : 0,
            จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย : 0,
            จำนวนทุนยื่นขอแบบงบอ้อม : 0,
            ยอดทุนที่ได้รับ: 0,
            ยอดทุนที่ได้รับแบบไม่เบิกจ่าย : 0,
            ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย : 0,
            ยอดทุนที่ได้รับแบบงบอ้อม : 0,
            ยอดทุนที่ได้รับจากโครงการนวัตกรรมนักศึกษา: 0,
          }));

          for(let i = 0;i<12;i++){
            
            const index = months.indexOf(months[i])
            console.log(index)
            const Projects = filterByMonth(response.data, i);
            console.log(Projects);
            console.log(monthlySummary[index])
            monthlySummary[index].จำนวนโครงการที่ยื่นในระบบ = Projects.length
            monthlySummary[index].จำนวนนักวิจัยที่ยื่นโครงการในระบบ = Array.from(
              new Set(Projects.map((item) => item.head_researcher 
              ))
            ).filter((headResearcher) => headResearcher).length
            monthlySummary[index].โครงการที่ถูกอนุมัติ = Projects.filter((item)=>item.project_status === 'อนุมัติ').length
            monthlySummary[index].โครงการที่ไม่อนุมัติ = Projects.filter((item)=>item.project_status === 'ไม่อนุมัติ').length
            monthlySummary[index].ยอดทุนที่ได้รับ = Projects.reduce(
              (sum, item) => sum + (item.AllSum || 0), 
              0
            );
          
            console.log(Projects)
          console.log(Array.from(
            new Set(Projects.map((item) => item.head_researcher 
            ))
          ))}

          setSummarydata(monthlySummary)

          const uniqueFacIDs = Array.from(new Set(response.data.map((item: { Fac_ID: any }) => item.Fac_ID)));

          const FacSum = uniqueFacIDs.map((Fac_ID) => {
            const facultyProjects = response.data.filter((item: any) => item.Fac_ID == Fac_ID);
            const faculty = Fac.find((item: any) => item.Fac_ID == Fac_ID);
            const uniqueResearchers = Array.from(new Set(facultyProjects.map((item: any) => item.head_researcher)));
          
            return {
              name: String(faculty?.Fac_NameTH || Fac_ID),
              จำนวนโครงการที่ยื่นในระบบ: facultyProjects.length,
              จำนวนนักวิจัยที่ยื่นโครงการในระบบ: uniqueResearchers.filter(Boolean).length,
              โครงการที่ถูกอนุมัติ: facultyProjects.filter((item: any) => item.project_status === 'อนุมัติ').length,
              โครงการที่ไม่อนุมัติ: facultyProjects.filter((item: any) => item.project_status === 'ไม่อนุมัติ').length,
              ยอดทุนที่ได้รับ: facultyProjects.reduce((sum: number, item: any) => sum + (item.AllSum || 0), 0),
              ยอดทุนที่ขอ: facultyProjects.reduce((sum: number, item: any) => sum + (item.AllSumHis || 0), 0),
              จำนวนทุนยื่นขอแบบไม่เบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.MonetarySum || 0), 0),
              จำนวนทุนยื่นขอแบบตัวเงินเบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.NonMonetarySum || 0), 0),
              จำนวนทุนยื่นขอแบบงบอ้อม : facultyProjects.reduce((sum: number, item: any) => sum + (item.IndirectSum || 0), 0),
              ยอดทุนที่ได้รับแบบไม่เบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.MonetarySumHis || 0), 0),
              ยอดทุนที่ได้รับแบบตัวเงินเบิกจ่าย : facultyProjects.reduce((sum: number, item: any) => sum + (item.NonMonetarySumHis || 0), 0),
              ยอดทุนที่ได้รับแบบงบอ้อม : facultyProjects.reduce((sum: number, item: any) => sum + (item.IndirectSumHis || 0), 0),
              ยอดทุนที่ได้รับจากโครงการนวัตกรรมนักศึกษา: facultyProjects.reduce((sum: number, item: any) => sum + (item.StudentBudgetSumHis || 0), 0),
            };
          });
          
          console.log(FacSum);
          setFacSummarydata(FacSum);
          
        }
        
        
        

        })
      }catch(error){
          notification.error({
            message:'บันทึกข้อมูลไม่สำเร็จ'
        })
      }
    }


    function checkstatus(status: string, tmp: number) {
      console.log(tmp);
    
      if (status === 'แก้ไข') {
        return (
          <>
            <Button
              type='primary'
              htmlType='reset'
              danger
              onClick={() => {
                setSelectedId(tmp);
                showModal();
              }}
            >
              ลบข้อมูล
            </Button>
            <Modal
              title="ยืนยันการลบ"
              open={open}
              onCancel={handleCancel}
              confirmLoading={loading}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  ยกเลิก
                </Button>,
                <Button
                  danger
                  key="submit"
                  type="primary"
                  loading={loading}
                  onClick={handleOk}
                >
                  ตกลง
                </Button>,
              ]}
            >
              <p>คุณต้องการลบโครงการดังกล่าวหรือไม่</p>
            </Modal>
          </>
        );
      } else {
        return <Button type="primary" danger disabled>ลบข้อมูล</Button>;
      }
    }
    if(sessionStorage.getItem("role")=='examiner'){
      return(<>
      <Flex justify='space-between' style={{padding:12}}><h1 className="text-3xl font-semibold ">รายชื่อโครงการที่กำลังยื่นขอเงินทุนวิจัย</h1></Flex>
      <br/>
      <hr/>
      <Collapse 
      style={{
        marginBottom:20
      }}
      items={[{
        label: 'ฟอร์มจำแนกข้อมูลตาม',
        children: 
        <Form
          form={form}
          onFinish={searchdata}
          >
        <Row>
          <Col span={24}>
            <Form.Item style={{marginLeft:20,marginTop:10}} name={'head_name_th'} label='นักวิจัยที่ต้องการสืบค้น' labelAlign='right'>
              <Space.Compact 
              style={{width:500}}
              >
                 <Input 
                 placeholder='กรุณาโปรดกรอกชื่อนักวิจัยที่นี่'
                 onChange={(e)=>handleChangeHead(e.target.value)}/>
              </Space.Compact>
              </Form.Item>
          </Col>
          
          
                  <Col >
                    <Radio.Group
                      style={{marginLeft:20,marginTop:13}}
                      value={isAcaYear}
                      onChange={(event) => setAcaYear(event.target.value)}
                      options={[
                        { value: true, label: "ปีการศึกษา" },
                        { value: false, label: "ปีปฏิทิน" },
                      ]}
                    />
                    </Col>
                    <Col>
                      {isAcaYear&&<Form.Item style={{marginLeft:20,marginTop:10}} name={'academicyear'} label='ปีการศึกษา'>
                        <DatePicker placeholder ='เลือกปีการศึกษา'  picker="year" style={{ width: 300 }} />
                      </Form.Item>||
                      <Form.Item style={{marginLeft:20,marginTop:10}} name={'year'} label='ปี'>
                        <DatePicker placeholder ='เลือกปี' picker="year" style={{ width: 300 }} />
                      </Form.Item>}
                    </Col>
            
          <Col >
            <Form.Item style={{marginLeft:20,marginTop:10}} name={'date'} label='วัน-เวลาที่ยื่นขอเงินทุน'>
              <RangePicker placeholder={['เริ่มต้น','สิ้นสุด']} style={{ width: 300 }}/>
            </Form.Item>     
          </Col>
        </Row>
        <Flex justify='flex-end'><Button type='primary' htmlType='submit'>ค้นหา</Button></Flex>
        
            
            
            
        </Form>
      }]}/>
      <br/>
      
      <Table
      columns={[
        {
          title:'ชื่อโครงการ',
          dataIndex:'project_name_th',
          key:'project_name_th',
      },
      {
          title:'ประเภทของโครงการวิจัย',
          dataIndex:'project_type',
          key:'project_type',
          responsive:['xl'],
          render:(_,record)=>{
            let project_type_ = ""
            switch(record.project_type){
              case 1:
                project_type_ = "งานวิจัยเชิงวัฒนธรรม";
                break;
              case 2:
                project_type_ = "งานนวัตกรรม";
                break;
              case 3:
                project_type_ = "งานวิจัยเพื่อสร้างองค์ประกอบความรู้พื้นฐาน";
                break;
              case 4:
                project_type_ = "งานวิจัยเชิงประยุกต์";
                break;
              case 5:
                project_type_ = "งานสร้างสรรค์(หนังสั้น สารคดี โฆษณา)";
                break;
              case 6:
                project_type_ = "งานวิจัยประเมินหลักสูตร";
                break;
              case 7:
                project_type_ = record.other_project_type;
                break;
            }
            return project_type_
          }
      },
      {
        title:'ผู้ทำโครงการวิจัย',
          dataIndex:'head_name_th',
          key:'head_name_th',
      },
      {
          title:'สาขาวิชาที่ทำการวิจัย',
          dataIndex:'oecd_type',
          key:'oecd_type',
          responsive:['xxl'],
          
      },
      {
        title: 'สถานะโครงการ',
        key: 'project_status',
        dataIndex: 'project_status',
        responsive:['lg'],
        render: (project_status: string) => {
          let color = 'purple';
          if (project_status === 'กำลังตรวจสอบ') {
            color = 'geekblue';
          } else if (project_status === 'แก้ไข'
            || project_status ==='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น'
            || project_status ==='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย '
            || project_status ==='แก้ไขตามความเห็นของกรรมการ'
          ) {
            color = 'yellow';
          } else if (project_status === 'รออนุมัติ') {
            color = 'geekblue';
          } else if (project_status === 'รอตรวจสอบจากผู้บังคับบัญชาเบื้องต้น' 
            
          ) {
            color = 'geekblue';
          }else if(project_status == 'รอการตรวจสอบผลอนุมัติจากกรรมการ'
            || project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'
            || project_status === 'รอผลอนุมัติจากคณะกรรมการ'
            || project_status === '	รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
          ){
            color = 'purple';
          }
          else if (project_status === 'ไม่อนุมัติ') {
            color = 'volcano';
          } else if (project_status === 'อนุมัติ') {
            color = 'green';
          }
          return <Tag color={color}>{project_status}</Tag>;
        },
      },
      {
        title:'วันเวลาที่ยื่นขอ',
        dataIndex:'date',
        key:'date',
        responsive:['md'],
        render: (date: string) => moment.utc(date).format('DD/MM/YYYY HH:mm:ss'),
        sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(), // Sorting function
        defaultSortOrder: 'ascend', // Optional: Set initial sort order
        
    },
  
        {
          title: '',
          key: 'action',
          width:100,
          render: (_, record) => (
            <Space size="middle">
                <Button type="primary"
                //  onClick={()=>sessionStorage.setItem("project_id",`${record.Budget_req_id}`)}
                 >
                  <a href={`/VRIIS/ReqInfo/${record.head_researcher}/${record.Budget_req_id}`}>ดูข้อมูล</a></Button>

            </Space>
          ),
        }
      ]}
      locale={{
        cancelSort: "คลิกเพื่อยกเลิกการจัดเรียง",
        triggerAsc: "คลิกเพื่อให้ขึ้นโครงการเก่าก่อน",
        triggerDesc: "คลิกเพื่อให้ขึ้นโครงการล่าสุดก่อน",
      }}
      dataSource={show}
      />
      </>)
    }else if(sessionStorage.getItem("role")=='staff'){
      return(
        <div>
          <LoadingOverlay active={creatingLoading} 
              spinner
              text='กำลังโหลดข้อมูล'>
          <Flex justify='space-between' style={{padding:12}}><h1 className="text-3xl font-semibold ">รายชื่อโครงการที่กำลังยื่นขอเงินทุนวิจัย</h1><Button size='large' onClick={()=>{setchoiceMod(true)}}>สร้างไฟล์สรุปผล</Button></Flex>
          <br/>
          <hr/>
          <br/>
          <Modal
          open={choiceMod}
          width={'50vw'}
          centered
          footer={<></>}
          onCancel={()=>setchoiceMod(false)}
          title="สร้างไฟลสรุปผล"
          >
            <br/>
            <Flex justify='center' >
              <Button type='default' onClick={()=>{handleCreateFiles()}}>ดูรายงานผลภาพรวม</Button> &nbsp;
              <Button type='default' onClick={()=>{handleCreateFilesForStaff()}}>ดูรายงานผลสำหรับเจ้าหน้าที่</Button>
            </Flex>
            <br/>
          </Modal>
          <Modal
          open={openMod}
          width={'70vw'}
          bodyStyle={{
            maxHeight: "70vh", 
            overflowY: "auto",  
          }}
          footer={<></>}
          onCancel={()=>setOpenMod(false)}
          title={
            <Flex justify="space-between" align="center" gap={12}>
              <div>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    lineHeight: 1.2,
                  }}
                >
                  ตัวอย่างข้อมูลในไฟล์
                </div>
  
                <div
                  style={{
                    fontSize: 13,
                    color: "#8c8c8c",
                    marginTop: 4,
                    fontWeight: 400,
                  }}
                >
                  ตรวจสอบข้อมูลก่อน Export เป็น PDF หรือ DOCX
                </div>
              </div>
  
              <Space>
                <Button
                  onClick={async (e) => {
                    e.stopPropagation();
  
                    try {
                      await exportHtmlToPdf(exportdata, {
                        fileName: `ไฟล์สรุปผล.pdf`,
                      });
  
                      message.success("Export PDF สำเร็จ");
                    } catch (error) {
                      console.error(error);
                      message.error("Export PDF ไม่สำเร็จ");
                    }
                  }}
                  disabled={PreviewLoading || !exportdata}
                >
                  Export PDF
                </Button>
  
                <Button
                  type="primary"
                  onClick={async (e) => {
                    e.stopPropagation();
  
                    try {
                      await exportHtmlToDocx(exportdata, {
                        fileName:  `ไฟล์สรุปผล.docx`,
                      });
  
                      message.success("Export DOCX สำเร็จ");
                    } catch (error) {
                      console.error(error);
                      message.error("Export DOCX ไม่สำเร็จ");
                    }
                  }}
                  disabled={PreviewLoading || !exportdata}
                >
                  Export DOCX
                </Button>
              </Space>
            </Flex>
          }>
            <LoadingOverlay active={PreviewLoading} 
              spinner
              text='กำลังโหลดข้อมูล'>
            <CKEditors myRef={myref} htmlBox={exportdata} toolstate={true}/></LoadingOverlay>
          </Modal>

          <br/>
          {search=='main'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการย้อนหลังใน 1 ปี</u></p></>
          ||search=='academicyear'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการประจำปีการศึกษา {year+543}</u></p></>
          ||search=='year'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการประจำปี {year+543}</u></p></>
          ||search=='search'&&<><p className='font-semibold text-3xl'><u>จำนวนที่โครงการที่กำลังแสดง</u></p></>
          }
          <Flex justify='center'>
          <ResponsiveContainer width="100%" height={300}>
          <LineChart data={summary_data}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Line type="monotone" dataKey="จำนวนโครงการที่ยื่นในระบบ" stroke="#8884d8" />
              <Line type="monotone" dataKey="จำนวนนักวิจัยที่ยื่นโครงการในระบบ" stroke="blue" />
              <Line type="monotone" dataKey="โครงการที่ถูกอนุมัติ" stroke="#82ca9d" />
              <Line type="monotone" dataKey="โครงการที่ไม่อนุมัติ" stroke="red" />
            </LineChart>
          </ResponsiveContainer>
          </Flex>
          {search=='main'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการที่ยื่นใน 1 ปีตามคณะวิชา</u></p></>
          ||search=='academicyear'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการประจำปีการศึกษา {year+543}</u></p></>
          ||search=='year'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการประจำปี {year+543}</u></p></>
          ||search=='search'&&<><p className='font-semibold text-3xl'><u>จำนวนที่โครงการในระบบที่กำลังแสดงอิงตามคณะวิชา</u></p></>
          }
          <Flex justify='center'>
          <ResponsiveContainer width="100%" height={300}>
          <BarChart data={fac_summary_data}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Bar onClick={(item)=>console.log(item.payload)} dataKey="จำนวนโครงการที่ยื่นในระบบ" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
              <Bar dataKey="จำนวนนักวิจัยที่ยื่นโครงการในระบบ" fill="pink" activeBar={<Rectangle fill="gold" stroke="purple" />} />
              <Bar dataKey="โครงการที่ถูกอนุมัติ" fill="#82ca9d" activeBar={<Rectangle fill="orange" stroke="yellow" />} />
            </BarChart>
          </ResponsiveContainer>
          </Flex>
          
          {search=='main'&&<><p className='font-semibold text-3xl'><u>ทุนวิจัยรวมใน 1 ปีตามคณะวิชา</u></p></>
          ||search=='academicyear'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการประจำปีการศึกษา {year+543}</u></p></>
          ||search=='year'&&<><p className='font-semibold text-3xl'><u>จำนวนโครงการประจำปี {year+543}</u></p></>
          ||search=='search'&&<><p className='font-semibold text-3xl'><u>ทุนวิจัยรวม</u></p></>
          }
          <Flex justify='center'>
          <ResponsiveContainer width="100%" height={300}>
          <BarChart data={fac_summary_data}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip content={<CustomTooltip />}/>
              <Legend />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Bar dataKey="ยอดทุนที่ขอ" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
              <Bar dataKey="ยอดทุนที่ได้รับ" fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
            </BarChart>
          </ResponsiveContainer>
          </Flex>
          <br/>
          <p className='font-semibold text-3xl'><u>จำนวนโครงการ</u></p>
          
          <Row gutter={10}>
            <Col span={6}>
            <Card style={{
              backgroundColor:'#4834d4',
              color:'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', 
            }}
            onClick={()=>{
              FilterData('รอตรวจสอบ')
            }
          } 
            hoverable bordered={false}>
              <p className='text-2xl font-semibold' style={{marginBottom:10}}>รอตรวจสอบ</p>
              <p className='text-5xl font-semibold'>{showAll.filter(
                (item) =>
                  item.project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย' ||
                  item.project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
                  item.project_status === 'รอผลอนุมัติจากคณะกรรมการ'||
                  item.project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
              ).length}</p>
            </Card>
            </Col>
            <Col span={6}>
            <Card style={{
              backgroundColor:'#f9ca24',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', 
            }} 
            onClick={()=>{
              FilterData('กำลังแก้ไข')
          } }
            hoverable bordered={false}>
              <p className='text-2xl font-semibold' style={{marginBottom:10}}>กำลังแก้ไข</p>
              <p className='text-5xl font-semibold'>{showAll.filter(
                (item) =>
                  item.project_status === 'แก้ไขตามความเห็นของกรรมการ' ||
                  item.project_status === 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'
              ).length}</p>
            </Card>
            </Col>
            <Col span={6}>
            <Card 
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', 
              backgroundColor:'#6ab04c',
              color:'white'
            }} 
            onClick={()=>{FilterData('อนุมัติ') }}
            hoverable 
            bordered={false}>
              <p className='text-2xl font-semibold' style={{marginBottom:10}}>อนุมัติ / ไม่อนุมัติแล้ว</p>
              <p className='text-5xl font-semibold'>{showAll.filter(
                (item) =>
                  item.project_status === 'อนุมัติ' ||
                  item.project_status === 'ไม่อนุมัติ'
              ).length}</p>
              </Card>
            </Col>
            <Col span={6}>
            <Card 
            style={{
              backgroundColor:'#c7ecee',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', // optional, to define card height
            }} 
          onClick={()=>{
            FilterData('ทั้งหมด')
            }} 
            hoverable bordered={false}>
              <p className='text-2xl font-semibold' style={{marginBottom:10}}>ทั้งหมด</p>
              <p className='text-5xl font-semibold'>{showAll.length}</p>
              </Card>
            </Col>
          </Row>
          <br/>
          {showCategory&&
          <><Flex justify='left' gap="small" >
            <Button type='primary'
            onClick={()=>FilterData('รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย')}
            >รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย</Button>
            <Button type='primary' style={{backgroundColor:'purple'}}
            onClick={()=>FilterData('รอผลอนุมัติจากคณะกรรมการ')}>รอผลอนุมัติจากคณะกรรมการ</Button>
            <Button type='primary' style={{backgroundColor:'#fa6400'}}
            onClick={()=>FilterData('รอการตรวจสอบผลอนุมัติจากกรรมการ')}>รอการตรวจสอบผลอนุมัติจากกรรมการ</Button>
            <Button type='primary' style={{backgroundColor:'#f9ca24',color:'black'}}
            onClick={()=>FilterData('รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่')}>รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่</Button></Flex><br/></>}
            <Row gutter={10}>
            <Col span={12}>
              <Card style={{
              backgroundColor:'#67B2D8',
              color:'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', 
              border:'none'
            }}
            hoverable
            onClick={()=>
              setshow(tmpqueryshow.filter((item)=>item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'))
            }
            >
              <p className='text-2xl font-semibold' style={{marginBottom:10}}>ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร</p>
              <p className='text-5xl font-semibold'>{TeacherRequestAmount}</p>
            </Card>
            </Col>
            <Col span={12}>
            <Card style={{
              backgroundColor:'#BF124D',
              color:'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', 
            }}
            hoverable
            onClick={()=>
              setshow(tmpqueryshow.filter((item)=>item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'))
            }>
                <p className='text-2xl font-semibold' style={{marginBottom:10}}>ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา</p>
                <p className='text-5xl font-semibold'>{StudentRequestAmount}</p>
            </Card>
            </Col>
            </Row>
          <br/>
          <Collapse
            items={[
              {
                label: 'ฟอร์มจำแนกข้อมูลตาม',
                children : 
                <Form
                  form={form}
                  onFinish={searchdata}>
                  <Row>
                    
                    <Col span={'12'}>
                      <Form.Item style={{marginLeft:20,marginTop:10}} label='หน่วยงานที่ต้องการค้นหา'>
                          <Select
                            showSearch
                            onChange={handleChange}
                            onClear={handleClear}
                            options={Fac.map((Fac) => ({
                              value: Fac.Fac_ID,
                              label: Number(Fac.Fac_ID) === 40 ? 'คณะวิศวกรรมศาสตร์และสถาปัตยกรรม' : Fac.Fac_NameTH,
                              key: Fac.Fac_NameTH,
                            }))}
                            placeholder="กรุณาเลือกหน่วยงาน"
                            filterOption={(input, option) =>
                              (option?.label as string).toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                          />
                          </Form.Item>
                    </Col>
                    <Col span={'12'}>
                    {showResOp&&
                    <Form.Item style={{marginLeft:20,marginTop:10}} name={'head_name_th'} label='นักวิจัยที่ต้องการสืบค้น' labelAlign='right'>
                        <Select
                        showSearch
                        onChange={handleChangeHead}

                        options={Array.isArray(ResOp) 
                          ? ResOp.map((item) => ({
                              value: `${item.Per_PrefixTH} ${item.Per_FNameTH} ${item.Per_LNameTH}`,
                              label: `${item.Per_PrefixTH} ${item.Per_FNameTH} ${item.Per_LNameTH}`,
                              key: `${item.Per_PrefixTH} ${item.Per_FNameTH} ${item.Per_LNameTH}`,
                            }))
                          : []}
                        placeholder='กรุณาเลือกนักวิจัย'
                        allowClear
                        />
                    </Form.Item>}
                    </Col>
                    {/* <Col span={'12'}>
                      <Form.Item name={'budget_type'} style={{marginLeft:20,marginTop:10}} label='ประเภททุน'>
                          <Select
                            showSearch
                            options={[
                              {
                                label:'ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร',
                                value:'ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'
                              },{
                                label:'ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา',
                                value:'ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'
                              },
                            ]}
                            placeholder="กรุณาเลือกหน่วยงาน"
                            filterOption={(input, option) =>
                              (option?.label as string).toLowerCase().includes(input.toLowerCase())
                            }
                            allowClear
                          />
                          </Form.Item>
                    </Col>
                    <Col span={'12'}>
                    </Col> */}
                    <Col >
                    <Radio.Group
                      style={{marginLeft:20,marginTop:13}}
                      value={isAcaYear}
                      onChange={(event) => setAcaYear(event.target.value)}
                      options={[
                        { value: true, label: "ปีการศึกษา" },
                        { value: false, label: "ปีปฏิทิน" },
                      ]}
                    />
                    </Col>
                    <Col>
                      {isAcaYear&&<Form.Item style={{marginLeft:20,marginTop:10}} name={'academicyear'} label='ปีการศึกษา'>
                        <DatePicker placeholder ='เลือกปีการศึกษา'  picker="year" style={{ width: 300 }} />
                      </Form.Item>||
                      <Form.Item style={{marginLeft:20,marginTop:10}} name={'year'} label='ปี'>
                        <DatePicker placeholder ='เลือกปี' picker="year" style={{ width: 300 }} />
                      </Form.Item>}
                    </Col>
                    
                    <Col >
                      <Form.Item style={{marginLeft:20,marginTop:10}} name={'date'} label='วัน-เวลาที่ยื่นขอเงินทุน'>
                        <RangePicker placeholder={['เริ่มต้น','สิ้นสุด']} style={{ width: 300 }}/>
                      </Form.Item>     
                    </Col>
                  </Row>
                  <Flex justify='flex-end'>
                    <Button type='primary' danger onClick={()=>
                      getProjectPreview()}>รีเซ็ตการค้นหา</Button> &nbsp;&nbsp;
                    <Button type='primary' htmlType='submit'>ค้นหา</Button></Flex>
                </Form>
              }
            ]}
          >

          </Collapse>
          <br/>
          <Table
            columns={[
              {
                title:'ชื่อโครงการ',
                dataIndex:'project_name_th',
                width:'25vw',
                key:'project_name_th',
                fixed: 'left',  
                 className: 'fixed-column',
              },
            {
              title:'จำนวนเงินทุนที่ได้รับ',
              dataIndex:'AllSum',
              key:'AllSum',
              render:(AllSum:number)=>{
                return(formatNumber(AllSum))
              }
            },
            {
              title:'ประเภททุน',
              dataIndex:'budget_type',
              key:'budget_type',
              responsive:['md','xl'],
            },
            {
                title:'ประเภทของโครงการวิจัย',
                dataIndex:'project_type',
                key:'project_type',
                responsive:['lg'],
                render:(_,record)=>{
                  let project_type_ = ""
                  switch(record.project_type){
                    case 1:
                      project_type_ = "งานวิจัยเชิงวัฒนธรรม";
                      break;
                    case 2:
                      project_type_ = "งานนวัตกรรม";
                      break;
                    case 3:
                      project_type_ = "งานวิจัยเพื่อสร้างองค์ประกอบความรู้พื้นฐาน";
                      break;
                    case 4:
                      project_type_ = "งานวิจัยเชิงประยุกต์";
                      break;
                    case 5:
                      project_type_ = "งานสร้างสรรค์(หนังสั้น สารคดี โฆษณา)";
                      break;
                    case 6:
                      project_type_ = "งานวิจัยประเมินหลักสูตร";
                      break;
                    case 7:
                      project_type_ = record.other_project_type;
                      break;
                  }
                  return project_type_
                }
            },
            
            {
              title:'ผู้ทำโครงการวิจัย',
                dataIndex:'head_name_th',
                key:'head_name_th',
                
                responsive:['md','xl'],
            },
            {
                title:'สาขาวิชาที่ทำการวิจัย',
                dataIndex:'Fac_ID',
                key:'Fac_ID',
                responsive:['xl'],
                render: (_,record)=>{
                  const faculty = Fac.find(fac => fac.Fac_ID == record.Fac_ID);
                  return <>{faculty?.Fac_NameTH || '-'}</>; 
                }
                
            },
            {
              title: 'สถานะโครงการ',
              key: 'project_status',
              dataIndex: 'project_status',
              responsive:['lg'],
              render: (project_status: string) => {
                let color = 'white';
                if (project_status === 'กำลังตรวจสอบ') {
                  color = 'geekblue';
                } else if (project_status === 'แก้ไข'
                  || project_status ==='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น'
                  || project_status ==='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'
                  || project_status ==='แก้ไขตามความเห็นของกรรมการ'
                ) {
                  color = 'yellow';
                } else if (project_status === 'รออนุมัติ') {
                  color = 'geekblue';
                } else if (project_status === 'รอตรวจสอบจากผู้บังคับบัญชาเบื้องต้น' 
                  || project_status === 'รอตรวจสอบจากเจ้าหน้าที่สำนักวิจัย'
                  || project_status === 'รอการตรวจสอบผลอนุมัติจากกรรมการ'||
                  project_status === 'รอตรวจสอบผลแก้ไขจากเจ้าหน้าที่'
                ) {
                  color = 'geekblue';
                }else if(project_status == 'รอผลอนุมัติจากคณะกรรมการ'){
                  color = 'purple';
                }
                else if (project_status === 'ไม่อนุมัติ') {
                  color = 'volcano';
                } else if (project_status === 'อนุมัติ') {
                  color = 'green';
                }
                return <Tag color={color}>{project_status}</Tag>;
              },
            },
            {
              title:'วันเวลาที่ยื่นขอ',
              dataIndex:'date',
              key:'date',
              responsive:['md'],
              render: (date: string) => moment.utc(date).format('DD/MM/YYYY HH:mm:ss'),
              sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(), // Sorting function
              defaultSortOrder: 'ascend', // Optional: Set initial sort order
              fixed: 'right',  
              className: 'fixed-column',
          },
        
              {
                title: '',
                key: 'action',
                width:100,
                fixed: 'right',  
                className: 'fixed-column',
                render: (_, record) => (
                  <Space size="middle">
                      <Button type="primary"
                      //  onClick={()=>sessionStorage.setItem("project_id",`${record.Budget_req_id}`)}
                      >
                        <a href={`/VRIIS/StaffBudgetReq/${record.head_researcher}/${record.Budget_req_id}`}>ดูข้อมูล</a></Button>

                  </Space>
                ),
              }
            ]}
            locale={{
              cancelSort: "คลิกเพื่อยกเลิกการจัดเรียง",
              triggerAsc: "คลิกเพื่อให้ขึ้นโครงการเก่าก่อน",
              triggerDesc: "คลิกเพื่อให้ขึ้นโครงการล่าสุดก่อน",
            }}
            dataSource={show}
            scroll={{ y: 500,
              x: 'max-content' }}
            />
        
        
        </LoadingOverlay></div>
      )
    }else if(sessionStorage.getItem("role")=='commitee'){
      return(
        <div>
          <Flex justify='space-between' style={{padding:12}}><h1 className="text-3xl font-semibold ">รายชื่อโครงการที่กำลังยื่นขอเงินทุนวิจัย</h1></Flex>
          <br/>
          <Row gutter={10}>
            <Col span={12}>
              <Card style={{
              backgroundColor:'#67B2D8',
              color:'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', 
              border:'none'
            }}
            hoverable
            onClick={()=>
              setshow(tmpqueryshow.filter((item)=>item.budget_type=='ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร'))
            }
            >
              <p className='text-2xl font-semibold' style={{marginBottom:10}}>ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร</p>
              <p className='text-5xl font-semibold'>{TeacherRequestAmount}</p>
            </Card>
            </Col>
            <Col span={12}>
            <Card style={{
              backgroundColor:'#BF124D',
              color:'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              height: '150px', 
            }}
            hoverable
            onClick={()=>
              setshow(tmpqueryshow.filter((item)=>item.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'))
            }>
                <p className='text-2xl font-semibold' style={{marginBottom:10}}>ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา</p>
                <p className='text-5xl font-semibold'>{StudentRequestAmount}</p>
            </Card>
            </Col>
            </Row>
            <br/>
          <Collapse
            items={[
              {
                label: 'ฟอร์มจำแนกข้อมูลตาม',
                children : 
                <Form
                  form={form}
                  onFinish={searchdata}>
                  <Row>
                    
                    <Col span={12}>
                    <Form.Item style={{ marginLeft: 20, marginTop: 10 }} label="หน่วยงานที่ต้องการค้นหา">
                      <Select
                        showSearch
                        onChange={handleChange}
                        onClear={handleClear}
                        options={Fac.map((Fac) => ({
                          value: Fac.Fac_ID,
                          label: Number(Fac.Fac_ID) === 40 ? 'คณะวิศวกรรมศาสตร์และสถาปัตยกรรม' : Fac.Fac_NameTH,
                          key: Fac.Fac_NameTH,
                        }))}
                        placeholder="กรุณาเลือกหน่วยงาน"
                        filterOption={(input, option) =>
                          (option?.label as string).toLowerCase().includes(input.toLowerCase())
                        }
                        allowClear
                      />
                    </Form.Item>

                    </Col>
                    <Col span={12}>
                   {showResOp&&<Form.Item style={{marginLeft:20,marginTop:10}} name={'head_name_th'} label='นักวิจัยที่ต้องการสืบค้น' labelAlign='right'>
                        <Select
                        showSearch
                        onChange={handleChangeHead}
                        options={Array.isArray(ResOp) 
                          ? ResOp.map((item) => ({
                              value: `${item.Per_PrefixTH} ${item.Per_FNameTH} ${item.Per_LNameTH}`,
                              label: `${item.Per_PrefixTH} ${item.Per_FNameTH} ${item.Per_LNameTH}`,
                              key: `${item.Per_PrefixTH} ${item.Per_FNameTH} ${item.Per_LNameTH}`,
                            }))
                          : []}
                        placeholder='กรุณาเลือกนักวิจัย'
                        allowClear
                        />
                    </Form.Item>}
                    </Col>
                    <Col >
                    <Radio.Group
                      style={{marginLeft:20,marginTop:13}}
                      value={isAcaYear}
                      onChange={(event) => setAcaYear(event.target.value)}
                      options={[
                        { value: true, label: "ปีการศึกษา" },
                        { value: false, label: "ปีปฏิทิน" },
                      ]}
                    />
                    </Col>
                    <Col>
                      {isAcaYear&&<Form.Item style={{marginLeft:20,marginTop:10}} name={'academicyear'} label='ปีการศึกษา'>
                        <DatePicker placeholder ='เลือกปีการศึกษา'  picker="year" style={{ width: 300 }} />
                      </Form.Item>||
                      <Form.Item style={{marginLeft:20,marginTop:10}} name={'year'} label='ปี'>
                        <DatePicker placeholder ='เลือกปี' picker="year" style={{ width: 300 }} />
                      </Form.Item>}
                    </Col>
                    <Col >
                      <Form.Item style={{marginLeft:20,marginTop:10}} name={'date'} label='วัน-เวลาที่ยื่นขอเงินทุน'>
                        <RangePicker placeholder={['เริ่มต้น','สิ้นสุด']} style={{ width: 300 }}/>
                      </Form.Item>     
                    </Col>
                  </Row>
                  <Flex justify='flex-end'><Button type='primary' htmlType='submit'>ค้นหา</Button></Flex>
                </Form>
              }
            ]}
          >

          </Collapse>
          <br/>
          <Table
            columns={[
              {
                title:'ชื่อโครงการ',
                dataIndex:'project_name_th',
                key:'project_name_th',
            },
            {
                title:'ประเภทของโครงการวิจัย',
                dataIndex:'project_type',
                key:'project_type',
                responsive:['xl'],
                render:(_,record)=>{
                  let project_type_ = ""
                  switch(record.project_type){
                    case 1:
                      project_type_ = "งานวิจัยเชิงวัฒนธรรม";
                      break;
                    case 2:
                      project_type_ = "งานนวัตกรรม";
                      break;
                    case 3:
                      project_type_ = "งานวิจัยเพื่อสร้างองค์ประกอบความรู้พื้นฐาน";
                      break;
                    case 4:
                      project_type_ = "งานวิจัยเชิงประยุกต์";
                      break;
                    case 5:
                      project_type_ = "งานสร้างสรรค์(หนังสั้น สารคดี โฆษณา)";
                      break;
                    case 6:
                      project_type_ = "งานวิจัยประเมินหลักสูตร";
                      break;
                    case 7:
                      project_type_ = record.other_project_type;
                      break;
                  }
                  return project_type_
                }
            },
            {
              title:'ผู้ทำโครงการวิจัย',
                dataIndex:'head_name_th',
                key:'head_name_th',
                responsive:['sm'],
            },
            {
                title:'สาขาวิชาที่ทำการวิจัย',
                dataIndex:'oecd_type',
                key:'oecd_type',
                responsive:['xxl'],
                
            },
            {
              title: 'สถานะโครงการ',
              key: 'project_status',
              dataIndex: 'project_status',
              responsive:['lg'],
              render: (_,record) => {
                let color = 'blue';
                if (record.project_status === 'กำลังตรวจสอบ') {
                  color = 'geekblue';
                } else if (record.project_status === 'แก้ไข'
                  || record.project_status ==='สั่งแก้ไขจากผู้บังคับบัญชาเบื้องต้น'
                  || record.project_status ==='สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย'
                  || record.project_status ==='แก้ไขตามความเห็นของกรรมการ'
                ) {
                  color = 'yellow';
                } else if (record.project_status === 'รออนุมัติ'||
                  !record.result
                ) {
                  color = 'geekblue';
                }  else if(record.project_status == 'รอการตรวจสอบผลอนุมัติจากกรรมการ'){
                  color = 'purple';
                }
                else if (record.project_status === 'ไม่อนุมัติ') {
                  color = 'volcano';
                } else if (record.project_status === 'อนุมัติ') {
                  color = 'green';
                }else if ( record.result
                ) {
                  color = 'purple';
                }
                return <Tag color={color}>{record.project_status}</Tag>;
              },
            },
            {
              title:'วันเวลาที่ยื่นขอ',
              dataIndex:'date',
              key:'date',
              responsive:['xl'],
              render: (date: string) => moment.utc(date).format('DD/MM/YYYY'),
              sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(), // Sorting function
              defaultSortOrder: 'ascend', // Optional: Set initial sort order
              
          },
          {
            title:'วันสิ้นสุดการอนุมัติ',
            dataIndex:'CommentIn',
            key:'CommentIn',
            responsive:['md'],
            render: (CommentIn: string, record: any) => {
              const isDueDate = moment(CommentIn).isBefore(moment(), 'day'); // Checks if it's past due
              const isPendingApproval = record.project_status === 'รอผลอนุมัติจากคณะกรรมการ';
            
              return (
                <span style={{ color: !isDueDate && isPendingApproval ? '#FFB200' : 'inherit' }}>
                  {moment(CommentIn).format('DD/MM/YYYY')}
                </span>
              );
            },
            sorter: (a, b) => moment(a.CommentIn).unix() - moment(b.CommentIn).unix(), // Sorting function
            defaultSortOrder: 'ascend', // Optional: Set initial sort order
            
            },
        
              {
                title: '',
                key: 'action',
                width:100,
                render: (_, record) => (
                  <Space size="middle">
                      <Button type="primary"
                      //  onClick={()=>sessionStorage.setItem("project_id",`${record.Budget_req_id}`)}
                      >
                        <a href={`/VRIIS/CommitteeReqInfo/${record.head_researcher}/${record.Budget_req_id}`}>ดูข้อมูล</a></Button>
                  </Space>
                ),
              }
            ]}
            locale={{
              cancelSort: "คลิกเพื่อยกเลิกการจัดเรียง",
              triggerAsc: "คลิกเพื่อให้ขึ้นโครงการเก่าก่อน",
              triggerDesc: "คลิกเพื่อให้ขึ้นโครงการล่าสุดก่อน",
            }}
            dataSource={show}
            />
        </div>
      )
    }
    
    // 
    return (
      
      <>
      <title>ระบบยื่นขอเงินทุนโครงการวิจัย มหาวิทยาลัยวงษ์ชวลิตกุล</title>
      <Flex justify='space-between' style={{padding:12}}><h1 className="text-3xl font-semibold ">รายชื่อโครงการที่กำลังยื่นขอเงินทุนวิจัย</h1><a href={'/VRIIS/BudgetReqDraft'}><Button size={'large'}><PlusOutlined /> เพิ่มโครงการใหม่ </Button></a></Flex>
      <br/>
      
      <Table columns={columns} dataSource={RequestPreview}  footer={() => ''} />
 
      </>
      
    );}